/* eslint-disable max-len */
import React from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
  CardMedia,
  Paper,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { HidroDXEditor } from "../../components";
import Principios from "../../assets/mandala_gistm.png";

export const GISTMContent: React.FC = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down(1100));

  // 
  const descricaoGeral = `
## Descrição Geral do GISTM
---
#####
O **GISTM** (Global Industry Standard on Tailings Management) é uma norma internacional criada em 2020 para elevar os padrões de segurança na gestão de barragens de rejeitos na mineração. Iniciativa elaborada pelo Programa das Nações Unidas para o Meio Ambiente (PNUMA), dos Princípios para o Investimento Responsável (PRI) e do Conselho Internacional de Mineração e Metais (ICMM) o GISTM consolida um compromisso com a segurança, a responsabilidade social e a gestão transparente na mineração.
Segundo o International Mining, o ICMM publicará o relatório de progresso sobre o GISTM ainda este ano. Para saber mais detalhes sobre o desenvolvimento e as ações das empresas envolvidas, leia o post abaixo.`;

  const textoExplicativo = `
O GISTM estabelece **77 requisitos** baseados em **15 princípios fundamentais** que abordam governança, planejamento, monitoramento, resposta a emergências e transparência pública.
As empresas apresentarão o status de conformidade de cada instalação e medidas para suprir eventuais lacunas. **O ICMM consolidará esses dados e publicará um relatório sobre avanços.**
A organização afirma que continua cmoprometida em impulsionar o progresso na gestão segura, responsável e transparente de rejeitos na mineração.`;

  return (
    <Box
      sx={{
        p: "15px",
        gap: "15px",
        display: "flex",
        overflow: "hidden",
        backgroundColor: "background.default",
        height: isMobileOrTablet ? "auto" : "100vh",
        flexDirection: isMobileOrTablet ? "column" : "row",
      }}
    >
      {/* Área principal */}
      <Card
        sx={{
          flex: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardMedia
          loop
          autoPlay
          controls
          component="video"
          src="/videos/gistm.mp4"
          sx={{
            border: 0,
            width: "100%",
            objectFit: "cover",
            overflow: "hidden",
            borderRadius: "5px 5px 0 0",
            height: isMobileOrTablet ? "25vh" : "60vh",
          }}
        />

        <Box
          sx={{
            flex: 1,
            fontSize: 14,
            display: "flex",
            overflow: "hidden",
            textAlign: "justify",
            borderRadius: "0 0 7px 7px",
          }}
        >
          <HidroDXEditor readOnly startText={descricaoGeral} />
        </Box>
      </Card>

      {/* Painel lateral direito */}
      <Box
        sx={{
          flex: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: isMobileOrTablet ? "auto" : "100%",
        }}
      >
        <Card
          sx={{
            flex: 1,
            boxShadow: 3,
            borderRadius: 2,
            display: "flex",
            overflow: "hidden",
            flexDirection: "column",
          }}
        >
          <CardContent
            sx={{
              flex: 1,
              fontSize: 14,
              display: "flex",
              overflowY: "auto",
              textAlign: "justify",
              alignItems: "center",
              maxHeight: isMobileOrTablet ? "auto" : "100%",
            }}
          >
            <HidroDXEditor readOnly startText={textoExplicativo} />
          </CardContent>
        </Card>

        <Paper
          elevation={1}
          sx={{
            display: "flex",
            borderRadius: "50%",
            alignItems: "center",
            aspectRatio: "1 / 1",
            flexDirection: "column",
            backgroundSize: "cover",
            justifyContent: "center",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${Principios})`
          }}
        />
      </Box>
    </Box>
  );
};
